// extracted by mini-css-extract-plugin
export var catList = "JobPostings-module--cat-list--3RufH";
export var category = "JobPostings-module--category--214X-";
export var hr = "JobPostings-module--hr--3VsRN";
export var job = "JobPostings-module--job--2R3jO";
export var location = "JobPostings-module--location--2bUCC";
export var heading = "JobPostings-module--heading--3fTyR";